module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/spot01_american-village-5df284782c3f32d5cfd619390dff1f94.jpg";